import api from "api";

/**
 * Registro de buscas. A busca em si a API registra sozinha quando o pedido
 * leva `search_session`; aqui só o clique num resultado.
 */
const searchLog = {
    // { search_session, item_type: 'event' | 'establishment', item_slug, position }
    click: (payload) => {
        return api().post('/search-clicks', payload);
    },
};

export default searchLog;
